import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type AuditLogsQueryVariables = GraphQLTypes.Exact<{
  auditLogsFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.AuditLogsFiltersInput>;
}>;

export type AuditLogsQueryResult = { __typename?: 'Query' } & {
  auditLogs?: GraphQLTypes.Maybe<
    { __typename?: 'AuditLogsConnection' } & Pick<GraphQLTypes.AuditLogsConnection, 'totalCount'> & {
        nodes: Array<
          { __typename?: 'AuditLog' } & Pick<
            GraphQLTypes.AuditLog,
            | 'actionTimestamp'
            | 'actionType'
            | 'displayNewValue'
            | 'displayOldValue'
            | 'field'
            | 'id'
            | 'newValue'
            | 'oldValue'
            | 'source'
            | 'updateReason'
          > & { user?: GraphQLTypes.Maybe<{ __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id' | 'name'>> }
        >;
      }
  >;
};

export const AuditLogsDocument = gql`
  query auditLogs($auditLogsFiltersInput: AuditLogsFiltersInput) {
    auditLogs(auditLogsFiltersInput: $auditLogsFiltersInput) {
      nodes {
        actionTimestamp
        actionType
        displayNewValue
        displayOldValue
        field
        id
        newValue
        oldValue
        source
        updateReason
        user {
          id
          name
        }
      }
      totalCount
    }
  }
`;
